var _rect, _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackageGrayConfigYellowLightBlueBgRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#5062F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8328 6.23585C16.1755 5.92139 15.4211 5.92138 14.7638 6.23585L6.28684 10.2913C5.98934 10.4336 5.79834 10.7458 5.79834 11.0897V19.4735C5.79834 20.4931 6.358 21.421 7.2347 21.8547L15.4438 25.9167C15.665 26.0261 15.9207 26.0278 16.1432 25.9214L24.3328 22.0034C25.2253 21.5764 25.7983 20.6399 25.7983 19.608V11.0897C25.7983 10.7458 25.6073 10.4336 25.3098 10.2913L16.8328 6.23585ZM16 7C15.7809 6.89518 14.5 7.47093 14.7638 7.33952L7.2347 11.0897L12 13.5L21 9.5L16 7ZM22 10L12.8817 14L15.5 15.5L24.7232 11.0897L22 10ZM25 12L16 16.0399V25L23.7983 21C24.0958 20.8577 25 20.5265 25 19.5V12ZM14.965 24.5V16.0399L12.8817 15.0432L12.7983 23.5L14.965 24.5ZM11.7983 23V14.5117L6.79834 12V19.5C6.79834 19.8399 7.2347 20.7971 7.79834 21L11.7983 23Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8808 17.1724C23.3495 16.2626 24.6505 16.2626 25.1192 17.1724V17.1724C25.4009 17.7192 26.0364 17.9824 26.6222 17.795V17.795C27.597 17.4831 28.5169 18.403 28.205 19.3778V19.3778C28.0176 19.9636 28.2808 20.5991 28.8276 20.8808V20.8808C29.7374 21.3495 29.7374 22.6505 28.8276 23.1192V23.1192C28.2808 23.4009 28.0176 24.0364 28.205 24.6222V24.6222C28.5169 25.597 27.597 26.5169 26.6222 26.205V26.205C26.0364 26.0176 25.4009 26.2808 25.1192 26.8276V26.8276C24.6505 27.7374 23.3495 27.7374 22.8808 26.8276V26.8276C22.5991 26.2808 21.9636 26.0176 21.3778 26.205V26.205C20.403 26.5169 19.4831 25.597 19.795 24.6222V24.6222C19.9824 24.0364 19.7192 23.4009 19.1724 23.1192V23.1192C18.2626 22.6505 18.2626 21.3495 19.1724 20.8808V20.8808C19.7192 20.5991 19.9824 19.9636 19.795 19.3778V19.3778C19.4831 18.403 20.403 17.4831 21.3778 17.795V17.795C21.9636 17.9824 22.5991 17.7192 22.8808 17.1724V17.1724Z",
    stroke: "#F2B90D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 22,
    r: 2,
    stroke: "#F2B90D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackageGrayConfigYellowLightBlueBgRounded);
export default __webpack_public_path__ + "static/media/packageGrayConfigYellowLightBlueBgRounded.0b84b2a7565fbc64afce9cca9960e234.svg";
export { ForwardRef as ReactComponent };